<template>
    <zen-message-modal
        :isOpen="isOpen"
        title="Scheduled Target Change"
        :wide="true"
    >
        <div class="space-y-8 divide-y divide-taupe-200">
            <div class="w-full">
                <div>
                    <p class="mt-1 text-sm text-taupe-500">
                        This change will take effect at the scheduled time
                        listed below.
                    </p>
                </div>

                <div
                    class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 w-full"
                >
                    <div class="sm:col-span-6">
                        <div class="block text-sm font-medium text-taupe-800">
                            Flag
                        </div>
                        <div>
                            {{ flagName }}
                        </div>
                        <div class="font-mono break-all">
                            {{ flagKey }}
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="block text-sm font-medium text-taupe-800">
                            Old value
                        </div>
                        <div class="font-mono break-all">
                            {{
                                currentValueDisplay != ''
                                    ? currentValueDisplay
                                    : '(empty)'
                            }}
                        </div>
                    </div>

                    <div class="sm:col-span-3">
                        <div class="block text-sm font-medium text-taupe-800">
                            New value
                        </div>
                        <div class="font-mono break-all">
                            {{
                                newValueDisplay != ''
                                    ? newValueDisplay
                                    : '(empty)'
                            }}
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="block text-sm font-medium text-taupe-800">
                            Scheduled At:
                        </div>
                        <div>
                            <zen-date-time :value="scheduledAt" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Close
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'ViewScheduledChangeModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        flagName: {
            type: String,
            default: null,
        },
        flagKey: {
            type: String,
            default: null,
        },
        currentValueDisplay: {
            type: String,
            default: null,
        },
        newValueDisplay: {
            type: String,
            default: null,
        },
        scheduledAt: {
            type: [String, Date],
            default: null,
        },
    },
    emits: ['close'],
}
</script>
